import { connect } from "react-redux";
import B2CLeadList from "./List";
import { bindActionCreators } from "redux";
import {
    b2cLeadListRequest
} from "../../../../../services/redux/CarLoan/action";

const mapStateToProps = (state) => ({
    b2cLeadListResponse : state.CarLoan.b2cLeadListResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        b2cLeadListRequest
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(B2CLeadList);